import ApiService from './ApiService';

export const getPrivacyPolicy = async () =>
  ApiService.get('static/privacy-policy');
